<template>
    <v-modal
        title="Add Columns"
        @close="handleClose"
        size="large"
        v-show="isVisible">
        <div slot="contents">
            <div class="modal-content">
                <p class="stack-m">Select the columns you want to include in your segment.</p>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <r-input
                            label="Search columns"
                            v-model="searchValue"/>
                    </div>
                </div>
            </div>
            <div class="modal-content is-scrollable">
                <ol class="list list-group list-divided"
                    v-for="(field, index) in columnsList">
                    <li class="list-item cursor-pointer stack-m">
                        <v-checkbox
                            :key="`${field.value}-${index}`"
                            :value="true"
                            :label="field.label"
                            :selected="field.selected"
                            @input="toggleColumn(index)">
                        </v-checkbox>
                    </li>
                </ol>
            </div>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="update">Apply</r-button>
        </template>
        <template slot="left-actions">
            <r-button @click="resetFields">Revert to default</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {vCheckbox} from '@/components/form';

    export default {
        name: 'columns-list-modal',
        components: {
            vModal,
            vCheckbox,
        },
        props: {
            isVisible: {
                type: Boolean,
                required: true,
            },
            columns: {
                type: Array,
                required: true,
            },
            defaultColumns: Array,
            availableColumns: {
                type: Array,
                required: true,
            },
        },
        watch: {
            columns(columns) {
                this.selectedColumns = [...columns];
                this.initSelectedColumns = [...columns];
            },
        },
        data() {
            return {
                searchValue: '',
                initSelectedColumns: [...this.columns],
                selectedColumns: [...this.columns],
            };
        },
        computed: {
            columnsList() {
                const selected = this.selectedColumns;
                const selectedValues = this.selectedColumns.map(field => field.value);
                const available = this.availableColumns.filter(field => !selectedValues.includes(field.value));
                const columnList = [
                    ...selected,
                    ...available,
                ].map(field => ({
                    ...field,
                    selected: selected.includes(field),
                }));

                const searchValue = this.searchValue.toLowerCase();
                return searchValue
                    ? columnList.filter(({label}) => label.toLowerCase().includes(searchValue))
                    : columnList;
            },
        },
        methods: {
            toggleColumn(index) {
                const column = this.columnsList[index];
                let columns = [...this.selectedColumns];

                if (column.selected) {
                    columns = columns.filter(element => column.value !== element.value);
                } else {
                    columns.push(column);
                }
                this.selectedColumns = columns;
            },
            resetFields() {
                this.searchValue = '';
                this.selectedColumns = [...this.defaultColumns];
            },
            update() {
                this.$emit('update', [...this.selectedColumns]);
                this.$emit('close');
            },
            handleClose() {
                this.$emit('close');
            },
        },
    };
</script>
